import {useImageSource} from '@/composables/use-image-source.js'
import {useErrorHandling} from '@/composables/use-error-handling.js'
import {ref, computed, watchEffect} from 'vue'

//Helper to load image
async function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = src
    img.onload = () => resolve(img)
    img.onerror = () => reject(new Error('Error loading image'))
  })
}

/**
 * Image composable
 */
export function useImage(src, isImageKey) {

  //Image refs
  const image = ref(null)
  const isLoading = ref(true)
  const hasLoaded = ref(false)
  const imageWidth = computed(() => image.value?.width)
  const imageHeight = computed(() => image.value?.height)
  const imageRatio = computed(() => {
    if (image.value) {
      return imageHeight.value / imageWidth.value
    }
    return 0
  })

  //Determine image source (input could be a File, image key, or URL)
  const {imageSrc} = useImageSource(src, isImageKey)
  const {processError} = useErrorHandling()

  //Load image from source
  watchEffect(async () => {
    if (imageSrc.value) {
      try {
        image.value = await loadImage(imageSrc.value)
        hasLoaded.value = true
      }
      catch (error) {
        processError(error)
      }
      finally {
        isLoading.value = false
      }
    }
  })

  //Expose interface
  return {
    image,
    isLoading,
    hasLoaded,
    imageWidth,
    imageHeight,
    imageRatio,
  }
}
